var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 34,
    viewBox: "0 0 30 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6271 6.60881C21.9602 6.03442 22.6993 5.83492 23.2446 6.21382C25.5121 7.7893 27.2982 9.9759 28.3878 12.5304C29.6352 15.4547 29.9029 18.704 29.151 21.793C28.3991 24.882 26.6678 27.6448 24.2159 29.6686C21.7641 31.6923 18.7232 32.8684 15.5477 33.0211C12.3721 33.1739 9.23243 32.295 6.59766 30.5159C3.96289 28.7367 1.97451 26.1529 0.929597 23.1503C-0.115315 20.1477 -0.160658 16.8876 0.800343 13.8572C1.63982 11.2099 3.20786 8.86199 5.31366 7.07618C5.82009 6.6467 6.5749 6.77436 6.96166 7.31412V7.31412C7.34842 7.85389 7.21979 8.60079 6.72026 9.03828C5.03309 10.5159 3.77502 12.4317 3.0925 14.584C2.28839 17.1198 2.32633 19.8476 3.20065 22.36C4.07497 24.8723 5.73873 27.0344 7.94334 28.523C10.1479 30.0117 12.7751 30.7471 15.4321 30.6193C18.0892 30.4915 20.6336 29.5074 22.6852 27.814C24.7368 26.1207 26.1854 23.809 26.8146 21.2243C27.4438 18.6396 27.2198 15.9207 26.176 13.4739C25.2901 11.397 23.854 9.61076 22.0328 8.30185C21.4936 7.91431 21.2939 7.1832 21.6271 6.60881V6.60881Z",
    fill: "#FFF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.3984,
    y: 0.497681,
    width: 2.88472,
    height: 14.7347,
    rx: 1.44236,
    fill: "#FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.9f901e7b7ac8085f44e590251087410b.svg";
export { ForwardRef as ReactComponent };